// with leading zero like 01 hour, 01 min, 01 sec
export const convertSecondsIntoHours = (getSeconds: number, duration: number) => {
  let seconds = Math.round(getSeconds);
  const durationInSeconds = Math.round(duration);

  const hours = Math.floor(seconds / 3600);
  seconds -= hours * 3600;

  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;

  let timeInHours = `${hours >= 10 ? hours : "0" + hours}:${minutes >= 10 ? minutes : "0" + minutes
    }:${seconds >= 10 ? seconds : seconds.toString().padStart(2, "0")
    }`;
  let timeInWords = `${hours > 0 ? `${hours} Hour ` : ''}${minutes === 0 ? "" : minutes >= 10 ? minutes + " Min " : "0" + minutes + " Min "}${seconds === 0 ? "" : seconds >= 10 ? seconds + " Sec" : seconds.toString().padStart(2, "0") + " Sec"}`;
  let timeWithoutHours = "";
  if (hours === 0) {
    timeWithoutHours = `${minutes >= 10 ? minutes : "0" + minutes
      }:${seconds >= 10 ? seconds : seconds.toString().padStart(2, "0")
      }`;
  }

  if (Math.abs(getSeconds - duration) < 0.5) {
    timeInHours = `${Math.floor(durationInSeconds / 60)}:${(durationInSeconds % 60).toString().padStart(2, "0")
      }`;
    timeInWords = Math.floor(durationInSeconds / 60) === 0 ? `${(durationInSeconds % 60).toString().padStart(2, "0")
      } Sec` : `${Math.floor(durationInSeconds / 60)} Min ${(durationInSeconds % 60).toString().padStart(2, "0")
      } Sec`;
  }

  if (timeInWords === "") {
    timeInWords = "00 Sec"
  }

  return { timeInHours, timeInWords, timeWithoutHours };
};

// without leading zero like 1 hour, 1 min, 1 sec
export const convertSecondsIntoHoursWithoutZero = (getSeconds: number, duration: number) => {
  let seconds = Math.round(getSeconds);
  const durationInSeconds = Math.round(duration);

  const hours = Math.floor(seconds / 3600);
  seconds -= hours * 3600;

  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;

  let timeInHours = `${hours}:${minutes}:${seconds}`;
  let timeInWords = `${hours > 0 ? `${hours} Hour ` : ''}${minutes === 0 ? "" : minutes + " Min "}${seconds === 0 ? "" : seconds.toString() + " Sec"}`;

  if (Math.abs(getSeconds - duration) < 0.5) {
    timeInHours = `${Math.floor(durationInSeconds / 60)}:${(durationInSeconds % 60).toString()
      }`;
    timeInWords = Math.floor(durationInSeconds / 60) === 0 ? `${(durationInSeconds % 60).toString()
      } Sec` : `${Math.floor(durationInSeconds / 60)} Min ${(durationInSeconds % 60).toString()
      } Sec`;
  }

  if (timeInWords === "") {
    timeInWords = "0 Sec"
  }

  return { timeInHours, timeInWords };
};